<template>
    <div class="sc flex column">
        <div class="flex-item chart-title">{{ timeRangeText }}完成情况</div>
        <div class="flex grow center">
            <div class="sc-chart">
                <e-charts :options="options"
                    :init-options="initOptions"
                    ref="chart"
                    autoresize
                    @legendselectchanged="onLegendChanged" />
            </div>
        </div>
    </div>
</template>
<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import theme from '../components/theme'
import common from './common'
import Enum from '_u/enum'
import loopPlayTooltip from '_u/echarts/loop-play-tooltip'

const ORDER_DATA_SOURCE = Enum.create({
    "GD": ['G', "工单"],
    "RW": ['R', "任务"]
})
const LEDGENDS = ['按时完成', '超时完成', '未完成']

export default {
    name: 'FullStatus',

    mixins: [theme, common],

    components: {
        ECharts
    },

    props: {
        // 服务类别数据
        list: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            chartData: [],
            legends: {
                '按时完成': true,
                '超时完成': true,
                '未完成': true,
                lastLegendIndex: 2, // 最后一个显示legend的下标
            },
            finished: 0,
            total: 0,
            serviceType: this.$dict.NULL,
        }
    },

    watch: {
        list: {
            handler() {
                this.setData()
            },
            immediate: true,
        },

        orderDataSource: {
            handler() {
                this.setData()
            },
        },

        options(val){
            if(this.loopPlayer){
                this.loopPlayer.startLoop(val)
            }
        },
    },

    computed: {
        initOptions() {
            return {
                renderer: 'canvas'
            }
        },

        options() {
            let vm = this,
                curYear = new Date().getFullYear()

            // 数据列
            let series = LEDGENDS.map((k, i) => ({
                name: k,
                type: 'bar',
                stack: '总量',
                label: {
                    show: true,
                    position: 'top',
                    color: this.theme.osLabelColor,
                    formatter: sesLabelFormat,
                },
                barMaxWidth: 20,
                data: this.chartData.map(v => v.data[i])
            }))

            function sesLabelFormat(e) {
                var { seriesIndex, dataIndex } = e

                // 只显示第一列
                if (seriesIndex != vm.legends.lastLegendIndex) {
                    return ''
                }

                // 返回所有列的总和
                return series.reduce((acc, v) => {
                    return acc += vm.legends[v.name] && v.data[dataIndex] || 0
                }, 0)
            }

            return {
                color: ['#55CD6F', '#FFE464', '#FF3739'],
                tooltip: {
                    trigger: 'axis',
                    triggerOn: 'mousemove',
                    axisPointer: { // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                    },
                    formatter: function(params, ticket, callback) {
                        var list = ''

                        for (let index = 0; index < params.length; index++) {
                            const el = params[index],
                                total = vm.chartData[el.dataIndex].total,
                                percent = total ? (el.value / total * 100).toFixed(0) : 0

                            list += `<div class="flex">
                                <span class="flex-item osc-bar-name">${el.seriesName}：</span>
                                <span class="flex-item grow osc-bar-count">${el.value} </span>
                                <span class="flex-item osc-bar-value">${percent}%</span>
                            </div>`
                        }

                        var name = params[0].name
                        name = name.replace('-', '年') + '月'

                        return `<div class="osc-bar-tooltip">
                            <div class="osc-bar-tooltip-title">${name}</div>
                            ${list}
                        </div>`
                    }
                },
                legend: {
                    orient: "horizontal",
                    data: LEDGENDS,
                    itemWidth: this.dp2p(12),
                    itemHeight: this.dp2p(12),
                    textStyle: {
                        color: this.theme.osLabelColor,
                    },
                },
                grid: {
                    top: 36,
                    left: 16,
                    right: 6,
                    bottom: 20,
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: this.chartData.map(v => curYear + '-' + ('0' + v.m).slice(-2)),
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: this.theme.osLabelColor,
                        }
                    },
                    axisLabel: {
                        color: this.theme.osLabelColor,
                    },
                },
                yAxis: {
                    type: 'value',
                    splitLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: this.theme.osLabelColor,
                        }
                    },
                    axisLabel: {
                        color: this.theme.osLabelColor,
                    },
                },
                series,
            }
        },
    },

    mounted(){
        this.chart = this.$refs.chart
        this.loopPlayer = loopPlayTooltip(this.chart.chart, {
            seriesIndex: [0, 1, 2],
        })
    },

    methods: {
        onLegendChanged(e) {
            // 更新legend选择情况
            Object.assign(this.legends, e.selected)
            // 更新索引
            this.legends.lastLegendIndex = -1

            for (var i = LEDGENDS.length - 1; i >= 0; i--) {
                if (this.legends[LEDGENDS[i]]) {
                    this.legends.lastLegendIndex = i
                    break
                }
            }
            // 刷新图表 options必传
            this.$refs.chart.mergeOptions({})
        },

        setData() {
            this.$dict.get("service_type")
                .then(dict => {
                    this.serviceType = dict
                })
                .then(() => {
                    // delay: 0
                    // ing: 4
                    // m: "3"
                    // ontime: 2
                    // serviceType: "WX"
                    // total: 6
                    let result = []
                    let data = this.list

                    // 工单类型过滤
                    if (this.orderDataSource && this.orderDataSource != 'all') {
                        data = data.filter(v => v.orderDataSource == this.orderDataSource)
                    }

                    let serviceGroup = data.groupBy("serviceType"),
                        finished = 0,
                        total = 0

                    // 按照serviceType、m进行聚合统计
                    Object.keys(serviceGroup).forEach(t => {
                        var typeGroup = serviceGroup[t].groupBy("m")

                        Object.keys(typeGroup).forEach(m => {
                            var list = typeGroup[m]

                            result.push(list.reduce((acc, v) => {
                                acc.delay += v.delay
                                acc.ing += v.ing
                                acc.ontime += v.ontime
                                acc.total += v.total

                                // 全年统计
                                finished += v.delay + v.ontime
                                total += v.total

                                return acc
                            }, {
                                delay: 0,
                                ing: 0,
                                m: parseInt(m),
                                ontime: 0,
                                total: 0,
                            }))
                        })
                    })

                    // 全年数据合计
                    this.finished = finished
                    this.total = total

                    // 中间月份补齐
                    result = result.sort((a, b) => a.m - b.m)
                    result.forEach((v, i) => {
                        var next = result[i + 1]

                        // 月份缺失
                        if (next && next.m - v.m > 1) {
                            result.splice(i + 1, {
                                delay: 0,
                                ing: 0,
                                m: v.m + 1,
                                ontime: 0,
                                total: 0,
                            })
                        }
                    })

                    // 数据拼接
                    result = result.map(v => ({
                        m: v.m,
                        total: v.total,
                        data: [v.ontime, v.delay, v.ing]
                    }))

                    this.chartData = result
                })
        }
    }
}
</script>
<style lang="less"
    scoped>
@import '../components/theme.less';

.echarts {
    width: 100%;
    height: 100%;
}

.sc {
    height: 100%;

    &-chart {
        width: 920px;
        height: 260px;
    }
}
</style>